export default {
  brand: "Basetao Spreadsheet",
  nav: {
    home: "Accueil",
    guide: "Guide d'achat",
    categories: "Catégories",
  },
  buttons: {
    basetaoSpreadsheet: "Basetao Spreadsheet",
    buyNow: "Acheter maintenant",
    readGuide: "Lire le guide",
    visitMainSite: "Visiter le site principal",
    browseCategories: "Parcourir les catégories",
  },
  lang: {
    label: "Langue",
    english: "English",
    french: "Français",
    german: "Deutsch",
    spanish: "Español",
    portuguese: "Português",
  },
  footer: {
    tagline: "Votre ressource indépendante Basetao Spreadsheet.",
    disclaimer:
      "Ce site est une ressource d'information indépendante et n'est pas le site officiel Basetao, sauf indication contraire explicite.",
    categoriesTitle: "Catégories",
    resourcesTitle: "Ressources",
    guideLink: "Guide Basetao Spreadsheet",
    mainSiteLink: "Site principal",
    rights: "Tous droits réservés.",
  },
  notFound: {
    title: "Page introuvable",
    desc: "La page que vous recherchez a peut-être été déplacée ou n'existe plus. Retournez à l'accueil ou visitez le site principal pour continuer vos achats.",
    backHome: "Retour à l'accueil",
  },
};